import { render, staticRenderFns } from "./MyProjectsOfferDetailAnswerBox.vue?vue&type=template&id=6d0316e7&scoped=true"
import script from "./MyProjectsOfferDetailAnswerBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyProjectsOfferDetailAnswerBox.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MyProjectsOfferDetailAnswerBox.vue?vue&type=style&index=0&id=6d0316e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0316e7",
  null
  
)

export default component.exports